import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Tool from '@/components/Tool'
import Page from '@/components/Page'
import Glossary from '@/components/Glossary'

Vue.use(Router)

var routes = [
	{ name: 'Home', path: '/', component: Home },
	{ name: 'Create', path: '/profile/create', component: Tool },
	{ name: 'Open', path: '/profile/open', component: Tool },
	{ name: 'Page', path: '/:page', component: Page }
]

if (process.env.VUE_APP_MODE === 'patient') {
	routes.splice(1, 0, { name: 'Enter', path: '/enter/:code?', component: Home })
	routes.splice(2, 0, { name: 'Glossary', path: '/glossary', component: Glossary })
	routes.splice(3, 0, { name: 'Code', path: '/profile/code', component: Tool })
	routes.splice(4, 0, { name: 'Entry', path: '/profile/entry', component: Tool })
	routes.splice(5, 0, { name: 'Browse', path: '/profile/browse', component: Tool })
}

export default new Router({
	mode: 'history',
	routes: routes
})